import { Fragment } from "react";
import { Link } from "react-router-dom";

// Minimal markdown-ish renderer for CMS text: "## ", "### ", "- " and "1. " lists, "| a | b |" tables,
// [link text](/url), **bold**, blank-line paragraphs.
const INLINE = /(\[[^\]]+\]\([^)]+\)|\*\*[^*]+\*\*)/g;

const Inline = ({ text }) => String(text).split(INLINE).map((part, i) => {
  const link = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
  if (link) {
    const [, label, href] = link;
    return href.startsWith("/")
      ? <Link key={i} to={href}>{label}</Link>
      : <a key={i} href={href} target="_blank" rel="noopener noreferrer">{label}</a>;
  }
  if (/^\*\*[^*]+\*\*$/.test(part)) return <strong key={i}>{part.slice(2, -2)}</strong>;
  return <Fragment key={i}>{part}</Fragment>;
});

const cells = (row) => row.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim());

const Table = ({ lines }) => {
  const rows = lines.filter((l) => !/^\|?\s*:?-{2,}/.test(l.trim()));
  const [head, ...body] = rows.map(cells);
  return (
    <div className="table-wrap">
      <table>
        <thead><tr>{head.map((c, i) => <th key={i} scope="col"><Inline text={c} /></th>)}</tr></thead>
        <tbody>{body.map((r, i) => <tr key={i}>{r.map((c, j) => <td key={j} data-label={head[j]}><Inline text={c} /></td>)}</tr>)}</tbody>
      </table>
    </div>
  );
};

export const RichText = ({ text = "", className = "prose-dad" }) => {
  const blocks = String(text).split(/\n{2,}/);
  return (
    <div className={className}>
      {blocks.map((b, i) => {
        const t = b.trim();
        if (!t) return null;
        if (t.startsWith("### ")) return <h3 key={i}><Inline text={t.slice(4)} /></h3>;
        if (t.startsWith("## ")) return <h2 key={i}><Inline text={t.slice(3)} /></h2>;
        const lines = t.split("\n");
        if (lines.every((l) => l.trim().startsWith("|"))) return <Table key={i} lines={lines} />;
        if (lines.every((l) => l.trim().startsWith("- "))) {
          return <ul key={i}>{lines.map((l, j) => <li key={j}><Inline text={l.trim().slice(2)} /></li>)}</ul>;
        }
        if (lines.every((l) => /^\d+\.\s/.test(l.trim()))) {
          return <ol key={i}>{lines.map((l, j) => <li key={j}><Inline text={l.trim().replace(/^\d+\.\s/, "")} /></li>)}</ol>;
        }
        if (lines.length > 1 && lines[0].length < 60 && !/[.!]$/.test(lines[0])) {
          return <div key={i}><h3>{lines[0]}</h3><p><Inline text={lines.slice(1).join(" ")} /></p></div>;
        }
        return <p key={i}><Inline text={t} /></p>;
      })}
    </div>
  );
};
